export default "__VITE_ASSET__CbTUIJB6__"